import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { ClockCircleOutlined as WatchLaterOutlinedIcon } from '@ant-design/icons';
import { Alert, Badge } from 'antd';

import isAfter from 'date-fns/isAfter';
import subDays from 'date-fns/subDays';
import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Refund() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);
  const refund = (notifications || []).find(n => n.type === ENotificationType.REFUND);

  if (!refund?.quantity) return null;

  const refundExpiring = refund?.dueDates?.find(dueDates => {
    return isAfter(new Date(), subDays(new Date(dueDates.dueDate), 4));
  });

  return (
    <Link to='/producer/request-management'>
      <div className='px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]' id='refund-notification-link'>
        <div className='flex items-center justify-between'>
          <span className='text-sm font-medium text-[#37474f]'>Reembolsos pendentes</span>
          <Badge count={refund?.quantity || 0} showZero />
        </div>
        {refundExpiring && (
          <Alert
            showIcon
            icon={<WatchLaterOutlinedIcon />}
            type='error'
            className='mt-1.5 text-xs [&_.ant-alert-message]:text-xs'
            message='Seu prazo de resposta para alguns reembolsos está se esgotando.'
          />
        )}
      </div>
    </Link>
  );
}
